import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPowerbiComponent } from './simple-icons-powerbi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPowerbiComponent ],
    exports:      [ SimpleIconsPowerbiComponent ],
    bootstrap:    []
})
export class SimpleIconsPowerbiModule {}
